import { AttendeeInfo } from '../../dialogs/attendee-selection-dialog/interfaces/interfaces';
import { GoogleMeetMeetingAttendeeInterface } from '@vendasta/meetings';

export function convertAttendeeInfoToApiHeader(attendeeInfo: AttendeeInfo[]): GoogleMeetMeetingAttendeeInterface[] {
  const convertedAttendees: GoogleMeetMeetingAttendeeInterface[] = [];
  if (!attendeeInfo) {
    return convertedAttendees;
  }
  attendeeInfo.forEach((attendee) => {
    const convertedAttendee: GoogleMeetMeetingAttendeeInterface = {
      displayName: attendee.name,
      email: attendee.uniqueIdentifier,
    };
    convertedAttendees.push(convertedAttendee);
  });
  return convertedAttendees;
}
